module.exports = __webpack_public_path__ + "css/aos.css";